import React from 'react'

import PropTypes from 'prop-types'
import {Redirect} from 'react-router-dom'
import {useSelector} from 'react-redux'

import {makeStyles} from '@material-ui/core/styles'
import {AppBar, Container, Tab, Tabs} from '@material-ui/core'
import Box from "@material-ui/core/Box";

import Page from 'components/Page/Page'

import DailySummaries from './DailySummaries.js'
import CalRecycleMonthlyReport from './CalRecycleMonthlyReport.js'
import Logs from './Logs.js'
import DR6 from './DR6.js'
import DR14 from './DR14.js'
import EcosackReport from './EcosackReport.js'
import RIG3Report from './RIG3Report.js'


const useStyles = makeStyles((theme) => ({}))

const ReportingPage = ({children}) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  if (!auth.access_token) {
    return <Redirect to="/login"/>
  }

  function hasPermission(perm) {
    for (var i = 0; i < auth.permissions.length; i++) {
      if (auth.permissions[i][0] == perm[0] && auth.permissions[i][1] == perm[1]) {
        return true
      }
    }
    return false
  }

  return (
    <Page title="Reporting">
      <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="scrollable">
            <Tab label="Daily Summaries"/>
            <Tab label="CalRecycle Monthly Report"/>
            <Tab label="Logs"/>
            <Tab label="DR6"/>
            <Tab label="DR14"/>
            <Tab label="Ecosack"/>
            <Tab label="RIG3 Report"/>
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <DailySummaries/>
          }
        </TabPanel>

        <TabPanel value={value} index={1}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <CalRecycleMonthlyReport/>
          }
        </TabPanel>

        <TabPanel value={value} index={2}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <Logs/>
          }
        </TabPanel>

        <TabPanel value={value} index={3}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <DR6/>
          }
        </TabPanel>

        <TabPanel value={value} index={4}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <DR14/>
          }
        </TabPanel>
        <TabPanel value={value} index={5}>
          {hasPermission(["Admin", "admin"]) &&
            <EcosackReport/>
          }
        </TabPanel>

        <TabPanel value={value} index={6}>
          {(hasPermission(["Admin", "admin"]) || hasPermission(["Normal", "user"])) &&
            <RIG3Report/>
          }
        </TabPanel>

      </Container>
    </Page>
  )
}

export default ReportingPage

ReportingPage.propTypes = {
  children: PropTypes.node
}